<template>
  <div id="content" class="dlnkmediatheque_new_game container">

    <dlnkalert
        :message="message"
        :message_type="message_type"
        @close="close_message()"
    ></dlnkalert>

    <!-- Submit Project Section -->
    <div class="container space-1 space-bottom-2">
      <div class="w-lg-75 mx-lg-auto">
        <!-- Title -->
        <div class="text-center mb-4">
          <h1 v-if="typeof game.title !== 'undefined'">{{ game.title }}</h1>
          <h1 v-else>Ajouter un nouveau jeux</h1>
        </div>
        <!-- End Title -->

        <!-- Card -->
        <form method="post"
              @submit.prevent="submit_form"
              id="game_form"
              enctype="multipart/form-data"
              class="needs-validation" novalidate>

          <div class="card card-bordered shadow-none">
            <div class="card-body">

              <!-- Form Group -->
              <div class="row form-group">
                <label for="title" class="col-sm-3 col-form-label input-label">Nom du jeu :</label>

                <div class="col-sm-9">
                  <input type="text" class="form-control form-control-sm" name="game[title]" id="title" v-model="game.title"
                         required
                         minlength="3"
                         maxlength="255">
                  <div class="invalid-feedback">
                    Le nom du jeu doit contenir au moins 3 caractères.
                  </div>
                </div>
              </div>
              <!-- End Form Group -->

              <!-- Form Group -->
              <div class="row form-group">
                <label for="editor_id" class="col-sm-3 col-form-label input-label">Editeur</label>

                <div class="col-sm-9">
                  <select id="editor_id" name="game[editor_id]" class="custom-select custom-select-sm" required v-model="game.editor_id">
                    <option value="">-- Veuillez sélectionner un editeur --</option>
                    <option
                        v-for="editor in editors"
                        :key="editor.id"
                        :value="editor.id">
                      {{ editor.name }}
                    </option>
                  </select>
                  <div class="invalid-feedback">
                    Veuillez selectionner un editeur
                  </div>
                </div>
              </div>
              <!-- End Form Group -->

              <!-- Form Group -->
              <div class="row form-group">
                <label for="place_id" class="col-sm-3 col-form-label input-label">Lieu stockage</label>

                <div class="col-sm-9">
                  <select id="place_id" name="game[place_id]" class="custom-select custom-select-sm" required v-model="game.place_id">
                    <option value="">-- Veuillez sélectionner une antenne --</option>
                    <option
                        v-for="place in places"
                        :key="place.id"
                        :value="place.id">{{ place.name }}
                    </option>
                  </select>
                  <div class="invalid-feedback">
                    Veuillez selectionner une antenne
                  </div>
                </div>
              </div>
              <!-- End Form Group -->

              <!-- Form Group -->
              <div class="row form-group">
                <label for="genre_id" class="col-sm-3 col-form-label input-label">Genre</label>

                <div class="col-sm-9">
                  <select id="genre_id" name="game[genre_id]" class="custom-select custom-select-sm" required v-model="game.genre_id">
                    <option value="">-- Veuillez sélectionner un genre --</option>
                    <option
                        v-for="genre in genres"
                        :key="genre.id"
                        :value="genre.id">{{ genre.name }}
                    </option>
                  </select>
                  <div class="invalid-feedback">
                    Veuillez selectionner un genre
                  </div>
                </div>
              </div>
              <!-- End Form Group -->

              <!-- Form Group -->
              <div class="row form-group">
                <label for="age_range_id" class="col-sm-3 col-form-label input-label">Tranche d'âge</label>

                <div class="col-sm-9">
                  <select id="age_range_id" name="game[age_range_id]" class="custom-select custom-select-sm" required v-model="game.age_range_id">
                    <option value="">-- Veuillez sélectionner une tranche d'age --</option>
                    <option
                        v-for="age_range in age_ranges"
                        :key="age_range.id"
                        :value="age_range.id">{{ age_range.name }}
                    </option>
                  </select>
                  <div class="invalid-feedback">
                    Veuillez selectionner une tranche d'age
                  </div>
                </div>
              </div>
              <!-- End Form Group -->

              <div class="row form-group">

                <label for="picture" class="col-sm-3 col-form-label input-label mt-4">Photo</label>

                <figure class="col-md-6 align-content-stretch mb-5 mb-md-0"
                        data-toggle="tooltip" data-placement="top"
                        title="Image du jeu">
                  <img class="img-fluid max-w-33rem w-md-100 h-auto d-block mx-auto border border-light border-3"
                       id="picture"
                       :src="picture"
                       alt="Votre avatar"/>
                  <figcaption class="small bg-light text-center max-w-33rem w-md-100 mx-auto p-1">
                    Ajouter / modifier la photo
                    <a href="javascript:;" id="changePictureBtn" class="stretched-link" data-toggle="modal"
                       data-target="#change_image">
                      <i class="fa fa-question-circle"></i>
                    </a>
                  </figcaption>
                </figure>

                <dlnk-clipper
                    modal_id="change_image"
                    @imgURL="set_picture($event)"
                    :crop_ratio="1">
                </dlnk-clipper>

              </div>

              <!-- Form Group -->
              <div class="row form-group">
                <label for="description" class="col-sm-3 col-form-label input-label mt-4">Description</label>

                <div class="col-sm-9">

                  <ckeditor :editor="editor" v-model="game.description"
                            :config="editor_config" id="description" name="description"></ckeditor>

                </div>
              </div>
              <!-- End Form Group -->

            </div>
            <!-- End Card -->
            <div class="text-center mt-1 mb-4">
              <button type="submit" class="btn btn-primary px-lg-5">Enregistrer</button>
            </div>
          </div>
        </form>
      </div>
      <!-- End Submit Project Section -->
    </div>
  </div>

</template>

<script>

import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {

  props: {
    game_id: 0,
  },

  data: function () {
    return {
      game: Object(),
      age_ranges: Array(),
      editors: Array(),
      genres: Array(),
      places: Array(),
      picture: String,
      message: "",
      message_type: "",
      current_game_id: 0,
      method: "",
      editor: ClassicEditor,
      editor_config: {
        toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote', 'undo', 'redo'],
        heading: {
          options: [
            {model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph'},
            {model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1'},
            {model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2'},
            {model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3'}
          ]
        }
      },
    }
  },

  mounted() {
    if(this.game_id == 0) {
      this.method = 'post'
    } else {
      this.method = 'patch'
      this.current_game_id = this.game_id
    }

    this.picture = "/modules/dlnkaap/img/socialmedia.jpg"
    this.get_data()
  },

  methods: {

    close_message: function () {
      this.message = "";
      this.message_type = "";
    },

    clean_field: function () {
      this.picture = ""
      document.getElementById("game_form").reset();
      document.getElementById("game_form").classList.remove("was-validated");
    },

    set_picture: function (img_url) {
      this.picture = img_url
    },

    get_game: async function () {
      const _this = this;
      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "mediatheque_games/" + _this.current_game_id + ".json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      axios.get(api_url)
          .then(function (response) {
            _this.game = response.data
            _this.picture = response.data.picture
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },

    get_genres: async function () {
      const _this = this;
      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "mediatheque_game_genres.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      _this.customer = customer

      axios.get(api_url)
          .then(function (response) {
            _this.genres = response.data
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },

    get_editors: async function () {
      const _this = this;
      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "mediatheque_game_editors.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      _this.customer = customer

      axios.get(api_url)
          .then(function (response) {
            _this.editors = response.data
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },

    get_age_ranges: async function () {
      const _this = this;
      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "mediatheque_age_ranges.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      _this.customer = customer

      axios.get(api_url)
          .then(function (response) {
            _this.age_ranges = response.data
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },

    get_places: async function () {
      const _this = this;
      let [secure_key, customer_id, api_url, customer] = await get_token_2()
      api_url += "mediatheque_places.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      _this.customer = customer

      axios.get(api_url)
          .then(function (response) {
            _this.places = response.data
          })
          .catch(function (error) {
            console.log(error)
          })
          .then(function () {
                // always executed
              }
          );
    },

    get_data: function () {
      this.get_genres()
      this.get_editors()
      this.get_places()
      this.get_age_ranges()
      if(this.game_id > 0) {
        this.get_game()
      }
    },

    submit_form: async function () {
      let _this = this
      let method = ""
      let [secure_key, customer_id, api_url] = await get_token_2()

      if (_this.current_game_id == 0) {
        method = 'post'
        api_url += "mediatheque_games.json"
      } else {
        method = 'patch'
        api_url += `mediatheque_games/${_this.current_game_id}.json`
      }

      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      // const form_data = new FormData();
      const form_element = document.getElementById("game_form");
      const form_data = new FormData(form_element);
      form_data.append('picture_base64', _this.picture)
      form_data.append('game[description]', _this.game.description)

      axios({
        method: method,
        url: api_url,
        data: form_data
      })
          .then(function (response) {
            _this.message = "Le jeu est enregistré";
            _this.message_type = "alert-success";
            _this.game = Object()
            _this.current_game_id = 0
            _this.get_data()
            _this.clean_field()
          })
          .catch(function (error) {
            _this.message = ""

            if (typeof(error.response.data.mediatheque_age_range) !== 'undefined') _this.message += "&bull; &nbsp;" + error.response.data.mediatheque_age_range[0] + "<br>"
            if (typeof(error.response.data.mediatheque_editor) !== 'undefined') _this.message += "&bull; &nbsp;" + error.response.data.mediatheque_editor[0] + "<br>"
            if (typeof(error.response.data.mediatheque_genre) !== 'undefined') _this.message += "&bull; &nbsp;" + error.response.data.mediatheque_genre[0] + "<br>"
            if (typeof(error.response.data.mediatheque_place) !== 'undefined') _this.message += "&bull; &nbsp;" + error.response.data.mediatheque_place[0] + "<br>"
            if (typeof(error.response.data.title) !== 'undefined') _this.message += "&bull; &nbsp;" + error.response.data.title[0]

            _this.message_type = "alert-danger";
          });

    },
  }
}

</script>
